<template>
  <div class="pwdDialog" ref="pwdDialog">
    <el-dialog
      :visible.sync="isPwdShow"
      width="470px"
      :before-close="handleClose"
    >
      <div class="pwd">
        <div class="box">
          <div class="regist-tit">{{ title }}</div>

          <div class="list" style="padding-top:20px">
            <el-form :model="findPwdForm" status-icon>
              <el-form-item>
                <p class="hint-login" v-show="hintText">可使用老子云账号登录</p>
                <el-input
                  v-model.trim="findPwdForm.phone"
                  class="check-inp"
                  maxlength="11"
                  name="phone"
                  placeholder="请输入手机号"
                  @focus="mobileFocus"
                  @blur="mobileBlur"
                  v-show="phoneShowFor"
                >
                  <i
                    slot="prefix"
                    class="iconfont iconzhanghao"
                    ref="account"
                  />
                </el-input>
                <el-input
                  v-model.trim="findPwdForm.phone"
                  class="check-inp"
                  maxlength="11"
                  name="phone"
                  placeholder="请输入手机号"
                  :disabled="true"
                  @focus="mobileFocus"
                  @blur="mobileBlur"
                  v-show="phoneShowFind"
                >
                  <i
                    slot="prefix"
                    class="iconfont iconzhanghao"
                    ref="account"
                  />
                </el-input>
              </el-form-item>

              <!-- <div class="puzzle">
                <Puzzle @adopt="adopt" />
              </div> -->

              <sendCode
                ref="sendCode"
                v-model="findPwdForm.code"
                :phone="findPwdForm.phone"
                type="rebuild"
                @getSmsKey="getSmsKey"
              />
              <!-- <el-form-item>
                <el-input
                  v-model="findPwdForm.code"
                  placeholder="请输入短信验证码"
                  class="code_input"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  maxlength="6"
                ></el-input>
                <span
                  class="get_code"
                  @click="sendSysCode('smsUpdatePassword')"
                  >{{ codeButtonText }}</span
                >
              </el-form-item> -->

              <el-form-item prop="password" class="hide-check-icon">
                <el-input
                  v-model.trim="findPwdForm.password"
                  class="check-inp"
                  :type="passForm.show.new ? 'text' : 'password'"
                  maxlength="16"
                  name="password"
                  autocomplete="off"
                  placeholder="请输入新密码"
                  @focus="newPwdFocus"
                  @blur="newPwdBlur"
                >
                  <i
                    slot="suffix"
                    :class="
                      passForm.show.new
                        ? 'iconfont  iconyulan'
                        : 'iconfont  iconbiyanjing'
                    "
                    ref="pwdIcon"
                    @click="showNewPwd"
                  />
                  <i slot="prefix" class="iconfont  iconmima" ref="pwdPre" />
                </el-input>
              </el-form-item>
              <el-form-item prop="re_password" class="hide-check-icon">
                <el-input
                  v-model.trim="findPwdForm.re_password"
                  class="check-inp"
                  :type="passFormTwo.show.new ? 'text' : 'password'"
                  maxlength="16"
                  name="password"
                  autocomplete="off"
                  placeholder="请再次输入新密码"
                  @focus="confimPwdFocus"
                  @blur="confimPwdBlur"
                >
                  <i
                    slot="suffix"
                    :class="
                      passFormTwo.show.new
                        ? 'iconfont  iconyulan'
                        : 'iconfont  iconbiyanjing'
                    "
                    ref="confimPwdIcon"
                    @click="showNewPwdTwo"
                  />
                  <i slot="prefix" class="iconfont  iconmima" ref="pwdPre1" />
                </el-input>
              </el-form-item>
            </el-form>

            <el-button round class="btn-blue lb" @click="sure" data-agl-cvt="5"
              >确定</el-button
            >

            <div class="helper" v-show="returnLogin">
              <span style="color:#1458EA" @click="goLogin">返回登录</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  validatePhoneEmail,
  validatePhone,
  validatePwd,
} from "@/utils/validate";
import sendCode from "@/components/sendCode";
import Puzzle from "@/components/aliPuzzle";
import thirdLogin from "@/components/thirdLogin";
import agreement from "@/components/agreement";
import register from "@/components/register";
import userInfo from "@/mixins/userInfo";
import {
  api_findPwdByPhonee,
  api_userToken,
  api_send_verificaCode,
} from "@/api/login";
import { mapMutations, mapState, mapActions } from "vuex";
export default {
  name: "pwdDialog",
  props: {
    hintText: {
      type: Boolean,
      default: true,
    },
    phoneShowFor: {
      type: Boolean,
      default: true,
    },
    phoneShowFind: {
      type: Boolean,
      default: false,
    },
    returnLogin: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [userInfo],
  components: {
    sendCode,
    Puzzle,
    thirdLogin,
    agreement,
    register,
  },
  data() {
    const validatePwdRe = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请再次输入密码"));
      } else if (value != this.findPwdForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        if (this.findPwdForm.re_password) {
          if (this.findPwdForm.re_password.length < 6)
            callback(new Error("请输入正确的密码"));
        }
        callback();
      }
    };
    return {
      codeTxt: "发送验证码",
      passForm: {
        oldPass: "",
        newPass: "",
        checkPass: "",
        show: {
          old: false,
          new: false,
          check: false,
        },
      },
      passFormTwo: {
        oldPass: "",
        newPass: "",
        checkPass: "",
        show: {
          old: false,
          new: false,
          check: false,
        },
      },
      findPwdForm: {
        phone: this.$store.state.login.phone,
        password: "",
        code: "",
        re_password: "",
      },
      isPwdShow: false,
      rules: {
        phone: [{ validator: validatePhone, trigger: "blur" }],
        password: [{ validator: validatePwd, trigger: "blur" }],
        re_password: [{ validator: validatePwdRe, trigger: "blur" }],
      },
      verification: false,
      smsKey: "",
      isCodeDend: "",
      title: "找回密码",
      codeButtonText: "发送验证码",
      isReady: true,
      showCertification: false,
      userInfoRes: "",
    };
  },
  watch: {
    findPwdForm: {
      handler: function(n) {
        if (n.code) n.code = n.code.replace(/[^\d]/g, "");
        if (n.phone) n.phone = n.phone.replace(/[^\d]/g, "");
      },
      deep: true,
    },
  },
  created() {
    // this.sendSysCode = this.debounce(this.sendSysCode, 1000, true);
  },
  mounted() {
    const _this = this;

    // document.onkeydown = function(e) {
    //   const key = window.event.keyCode;
    //   if (key === 13) {
    //     _this.sure(); //方法
    //   }
    // };
  },
  //   beforeDestroy() {
  //     document.onkeydown = function() {
  //       const key = window.event.keyCode;
  //       if (key == 13) {
  //         console.log("13");
  //       }
  //     };
  //   },
  methods: {
     ...mapActions("login", {
      GETUSERINFO: "GETUSERINFO",
    }),
    //返回登录
    goLogin() {
      this.$root.loginVisible = true;
      this.isPwdShow = false;
    },
    handleClose(done) {
      done();
    },
    //更换密码图标
    showNewPwd() {
      this.passForm.show.new = !this.passForm.show.new;
    },
    showNewPwdTwo() {
      this.passFormTwo.show.new = !this.passFormTwo.show.new;
    },
    //手机号
    mobileFocus() {
      this.$refs.account.style.color = "#1458EA";
    },
    mobileBlur() {
      this.$refs.account.style.color = "#9E9FAB";
    },
    //新的密码框
    newPwdFocus() {
      this.$refs.pwdPre.style.color = "#1458EA";
    },
    newPwdBlur() {
      this.$refs.pwdPre.style.color = "#9E9FAB";
    },
    //确认密码框
    confimPwdFocus() {
      this.$refs.pwdPre1.style.color = "#1458EA";
    },
    confimPwdBlur() {
      this.$refs.pwdPre1.style.color = "#9E9FAB";
    },
    getSmsKey(val) {
      this.smsKey = val;
    },
    adopt() {
      this.verification = true;
      this.$refs.sendCode.getCode();
    },
    async sure() {
      if (!this.testPhone(this.findPwdForm.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      if (!this.findPwdForm.password) {
        this.$message.error("请输入密码");
        return;
      }

      if (
        this.findPwdForm.password.length < 6 ||
        this.findPwdForm.password.length > 16
      ) {
        this.$message.error("请输入6~16位字符的密码");
        return;
      }

      if (!this.findPwdForm.re_password) {
        this.$message.error("请确认密码");
        return;
      }
      if (this.findPwdForm.re_password != this.findPwdForm.password) {
        this.$message.error("两次密码需一致");
        return;
      }
      if (!this.smsKey) {
        this.$message.error("请获取验证码");
        return;
      }
      if (!this.findPwdForm.code) {
        this.$message.error("请输入验证码");
        return;
      }
      //   if (!this.verification) {
      //     document.getElementById("getCode").click();
      //     this.$message.error("请进行智能验证");
      //     return;
      //   }
      const _this = this;
      const res = await api_findPwdByPhonee({
        phoneno: _this.findPwdForm.phone,
        verifycode: _this.findPwdForm.code,
        password: _this.findPwdForm.password,
        smsKey: _this.smsKey,
      });
      // console.log(res);
      if (res.resp_code == 60000) {
        this.$message.success({
          showClose: true,
          message: "修改成功",
          type: "success",
        });

        const tokenRes = await api_userToken({
          username: _this.findPwdForm.phone,
          password: _this.findPwdForm.password,
        });
        // this.$root.pwdVisible = false;
        this.isPwdShow = false;
        const J = JSON.parse(tokenRes.datas);
        this.getAppuserinfo(J.access_token);
        if (this.title == "找回密码") {
          this.getAppuserinfoTwo(J.access_token, () => {
          this.goReturnUrl();
        });
         this.GETUSERINFO();
        }
        // 关闭页面
      } else {
        this.$message.error(res.resp_msg);
      }
    },
    close() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input__inner {
  height: 34px;
  line-height: 34px;
}

/deep/ .el-select .el-input .el-select__caret::before {
  content: "\e78f";
}
/deep/ .el-dialog__headerbtn {
  top: 30px;
  font-size: 19px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #182c49;
  position: relative;
  z-index: 99999;
}
/deep/ .el-dialog__header {
  padding: 0px;
}
.pwd {
  .regist-tit {
    font-size: 20px;
    color: #182c49;
    text-align: center;
    font-weight: bold;
    padding-bottom: 20px;
    border-bottom: 1px solid #e6e9f0;
  }
  .el-dialog__body {
    padding: 35px 20px;
  }
  .hint-login {
    font-size: 12px;
    color: #c0c3c8;
    margin-left: 11px;
  }
}
/deep/.el-button.is-disabled,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-color: #ddd;
  border-color: #ebeef5;
}

.foot-text {
  position: absolute;
  bottom: -35px;
  left: 50px;
  color: #fff;
}

.pwd {
  //   background: url('../assets/img/bg.png') no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;
  .text-wa {
    position: absolute;
    color: #ffffff;
    top: 35%;
    left: 29%;
    line-height: 33px;
  }

  .container-page {
    width: 1180px;
    margin: 0 auto;
  }
  .box {
    background: #fff;
    border-radius: 2px;
    box-sizing: border-box;
    position: relative;
    .helper {
      display: flex;
      justify-content: center;
      width: 320px;
      margin-top: 15px;
      font-size: 16px;
      /deep/ .el-checkbox__label {
        color: #0055f3;
      }
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #0055f3;
        border-color: #0055f3;
      }
      /deep/ .el-checkbox {
        vertical-align: middle;
      }
      .right {
        color: #8192a8;
        cursor: pointer;
        width: 100%;
        text-align: center;
        font-size: 14px;
        span {
          &:hover {
            color: #0055f3;
          }
        }
      }
    }
    .list {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: column;
      padding-top: 90px;
      .icon {
        color: #8192a8;
        font-size: 18px;
      }
      .puzzle {
        user-select: none;
        // margin-bottom: 20px;
      }
      .lb {
        width: 320px;
        height: 50px;
        border-radius: 40px;
        margin-left: 0;
        margin-top: 20px;
        /deep/ span {
          font-size: 16px;
        }
      }

      .login-btn {
        width: 320px;
        height: 60px;
        border-radius: 40px;
        background-color: #0055f3;
        color: #fff;
        text-align: center;
        line-height: 60px;
        margin-top: 25px;
        cursor: pointer;
        &:hover {
          background-color: rgba(0, 85, 243, 0.12);
        }
        span {
          text-align: center;
          font-size: 16px;
        }
      }
      .register {
        position: absolute;
        top: 255px;
        display: flex;
        align-items: center;
        border: solid 1px #ffbb8e;
        background-color: rgba(245, 82, 49, 0.12);
        height: 40px;
        width: 308px;
        border-radius: 4px;
        padding-left: 10px;
        p {
          color: #8192a8;
          font-size: 12px;
        }
        span {
          color: #ff1616;
          font-size: 12px;
          cursor: pointer;
        }
        i {
          color: #ff1616;
        }
      }
      .block {
        width: 340px;
        margin-left: 40px;
      }
      .tit {
        margin-right: 10px;
      }
    }
    .tab {
      text-align: center;
      padding: 0 30px;
      border-bottom: 1px solid #e6e9f0;
      li:first-child {
        // margin-right: 50px;
      }
      li {
        cursor: pointer;
        color: #132c4b;
        font-size: 20px;
        padding-bottom: 20px;
        border-bottom: 4px solid transparent;
        white-space: nowrap;
        display: inline-block;
        margin-left: 23px;
        position: relative;
        &:nth-child(1) {
          &::after {
            display: inline-block;
            content: "";
            width: 1px;
            height: 11px;
            background: #8b8b8b;
            position: absolute;
            right: 6px;
            top: 10px;
          }
        }
        span {
          font-size: 14px;
          display: block;
          transform: translate(-18px);
          font-weight: bold;
        }
      }
      .on {
        color: #1458ea;
        span {
          font-size: 20px;
        }
      }
    }
  }
}
.check-inp {
  width: 320px;
}

.code-inp {
  width: 200px;
}
/deep/.el-form-item {
  margin-bottom: 20px;
}
/deep/.el-input__inner {
  background-color: #e4e9f3;
}
.hide-check-icon {
  /deep/.el-input__suffix {
    /deep/.el-input__validateIcon {
      display: none;
    }
  }
}
.btn-blue {
  background: #1458ea;
  border: none;
  color: #ffffff;
  transition: all 0.2s linear;
}

.btn-blue:focus,
.btn-blue:hover {
  color: #ffffff;
  border-color: #1458ea;
  background-color: rgba(20, 88, 234, 0.8);
}

/deep/.el-input__inner:focus {
  color: #1458ea;
  border-color: #1458ea;
}
/deep/ .el-input__prefix:focus {
  color: #1458ea;
}
.code_input {
  width: 200px;
}
.get_code {
  margin-left: 20px;
  cursor: pointer;
  color: #1458ea;
}
</style>
